// crm-web/frontend/src/components/analytics/HeroCard.jsx
// Hero card generica reusable. Una sola fuente de verdad para el render de cards:
// cambiar estilo o threshold afecta todas las cards a la vez (OCP friendly).

const STATUS_BORDER = {
  neutral: 'border-l-blue-500 dark:border-l-blue-400',
  green: 'border-l-green-500 dark:border-l-green-400',
  amber: 'border-l-amber-500 dark:border-l-amber-400',
  red: 'border-l-red-500 dark:border-l-red-400',
}

const STATUS_VALUE_COLOR = {
  neutral: 'text-gray-900 dark:text-gray-100',
  green: 'text-green-700 dark:text-green-400',
  amber: 'text-amber-700 dark:text-amber-400',
  red: 'text-red-700 dark:text-red-400',
}

export default function HeroCard({
  title,
  value,
  subtitle,
  status = 'neutral',
  loading = false,
}) {
  if (loading) {
    return (
      <div className="bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-lg p-5 animate-pulse">
        <div className="h-3 bg-gray-200 dark:bg-gray-700 rounded w-1/2 mb-3" />
        <div className="h-8 bg-gray-200 dark:bg-gray-700 rounded w-3/4 mb-2" />
        <div className="h-3 bg-gray-200 dark:bg-gray-700 rounded w-1/3" />
      </div>
    )
  }

  return (
    <div
      className={`bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700
                  border-l-4 rounded-lg p-5 ${STATUS_BORDER[status]}`}
    >
      <div className="text-xs uppercase tracking-wider font-semibold text-gray-500 dark:text-gray-400">
        {title}
      </div>
      <div className={`text-4xl font-extrabold mt-2 ${STATUS_VALUE_COLOR[status]}`}>
        {value}
      </div>
      {subtitle && (
        <div className="text-xs text-gray-500 dark:text-gray-400 mt-1">
          {subtitle}
        </div>
      )}
    </div>
  )
}
